import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CoursesPage } from '@/app/courses/CoursesPage';
import { RequirePermission } from '@/modules/identity/public';

export const Route = createFileRoute('/_admin/cursos/')({
  validateSearch: z.object({
    status: z.enum(['draft', 'published', 'archived']).optional().catch(undefined),
    busca: z.string().optional().catch(undefined),
  }),
  component: function CoursesRoute() {
    const filters = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <RequirePermission anyOf={['cursos.ver']}>
        <CoursesPage
          filters={filters}
          // `replace`: digitar na busca não pode encher o histórico do navegador.
          onFiltersChange={(next) => navigate({ search: next, replace: true })}
        />
      </RequirePermission>
    );
  },
});
